import React from 'react'

const BannerComponent = () => {
    return (
        <>
            {/*  banner pc */}
            {/* <div className="banner-image container-fluid text-white text-center d-flex align-items-center justify-content-center"></div> */}
            <div className="w-100">
                <img src='./Banner.png' alt="Banner" className="img-fluid w-100" loading='lazy' />
            </div>

            <div className="container mt-4 mb-4">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-8">
                        <p className="text-justify mb-0 text-blue text-center fs-5">Conozca la <strong>experiencia clínica</strong> y los <strong>resultados con </strong></p>
                        <p className="text-justify mb-0 text-blue text-center fs-5 mb-2">Rybelsus<sup className="superindice">®</sup> en el <strong>paciente con DM2</strong> en Colombia.</p>
                    </div>
                    <div className='col-12 col-md-12 col-lg-4'>
                        <span className="d-none d-md-block d-lg-block d-xl-block badge badge-orange text-white">
                            <h3 className='fs-4 align-text-center'>Sea parte de esta experiencia</h3>
                        </span>

                        <span className="d-block d-md-none d-lg-none d-xl-none badge badge-orange text-white w-100">
                            <h3 className='fs-4'>Sea parte de esta experiencia</h3>
                        </span>
                    </div>
                </div>
            </div>
            <hr className='w-80 mx-5 mt-4 mb-3' style={{ borderTop: '2px solid #000' }} />
        </>
    )
}

export default BannerComponent;